import ChangeCard from './ChangeCard'
import { useTranslation } from 'react-i18next'
import { TYPE } from './MarketOverviewTable/MarketOverviewTable.settings'
import { useDSmarketOverviewData } from '../../../store/dataStore'
import { Col, Row } from 'reactstrap'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import Constants from '../../../utils/Constants'

const ChangeSection = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const marketOverviewData = useDSmarketOverviewData()

  const importerYearlyPositiveAbsoluteRef = useRef(null)
  const importerYearlyPositivePercentageRef = useRef(null)
  const importerMonthlyPositivePercentageRef = useRef(null)
  const exporterYearlyPositiveAbsoluteRef = useRef(null)
  const exporterMonthlyPositiveAbsoluteRef = useRef(null)
  const exporterYearlyNegativePercentageRef = useRef(null)
  const exporterMonthlyNegativePercentageRef = useRef(null)
  const importerMonthlyNegativePercentageRef = useRef(null)

  useImperativeHandle(ref, () => ({
    generateTablesPdf () {
      return [
        ...importerYearlyPositiveAbsoluteRef.current.generateTablePdf('importerYearlyPositiveAbsolute'),
        ...importerYearlyPositivePercentageRef.current.generateTablePdf('importerYearlyPositivePercentage'),
        ...importerMonthlyPositivePercentageRef.current.generateTablePdf('importerMonthlyPositivePercentage'),
        ...exporterYearlyPositiveAbsoluteRef.current.generateTablePdf('exporterYearlyPositiveAbsolute'),
        ...exporterMonthlyPositiveAbsoluteRef.current.generateTablePdf('exporterMonthlyPositiveAbsolute'),
        ...exporterYearlyNegativePercentageRef.current.generateTablePdf('exporterYearlyNegativePercentage'),
        ...exporterMonthlyNegativePercentageRef.current.generateTablePdf('exporterMonthlyNegativePercentage'),
        ...importerMonthlyNegativePercentageRef.current.generateTablePdf('importerMonthlyNegativePercentage')
      ]
    }
  }))

  // const getYear = (value, type) => {
  //   if (value?.length) {
  // NOTE: KEY from './MarketOverviewTable/MarketOverviewTable.settings'
  //     const date = type === KEY.YEARLY ? value[1]?.toString() : value[0]?.toString()
  //     return date.slice(0, 4)
  //   }
  // }

  return (<>
    <Row>
      <Col md="12">
        <ChangeCard
          ref={importerYearlyPositiveAbsoluteRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_09}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_09}
          title={t('mo_change_import_most_year')}
          type={TYPE.IMPORTER}
          isYearTable={true}
          data={marketOverviewData?.changes.importer.yearly?.positive}
          timeTags={marketOverviewData?.changes.importer.yearly?.timeTags}
          id={'importerGraphYearlyPositiveAbsolute'}
        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={importerYearlyPositivePercentageRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_10}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_10}
          title={t('mo_change_import_least_year')}
          type={TYPE.IMPORTER}
          isYearTable={true}
          data={marketOverviewData?.changes.importer.yearly?.negative}
          timeTags={marketOverviewData?.changes.importer.yearly?.timeTags}
          id={'importerGraphYearlyNegativeAbsolute'}
        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={importerMonthlyPositivePercentageRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_11}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_11}
          title={t('mo_change_import_most_month')}
          type={TYPE.IMPORTER}
          isYearTable={false}
          data={marketOverviewData?.changes.importer.monthly?.positive}
          timeTags={marketOverviewData?.changes.importer.monthly?.timeTags}
          id={'importerGraphMonthlyPositiveAbsolute'}
        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={exporterYearlyPositiveAbsoluteRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_12}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_12}
          title={t('mo_change_import_least_month')}
          type={TYPE.IMPORTER}
          isYearTable={false}
          data={marketOverviewData?.changes.importer.monthly?.negative}
          timeTags={marketOverviewData?.changes.importer.monthly?.timeTags}
          id={'importerGraphMonthlyNegativeAbsolute'}
        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={exporterMonthlyPositiveAbsoluteRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_13}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_13}
          title={t('mo_change_export_most_year')}
          type={TYPE.EXPORTER}
          isYearTable={true}
          data={marketOverviewData?.changes.exporter.yearly?.positive}
          timeTags={marketOverviewData?.changes.exporter.yearly?.timeTags}
          id={'exporterGraphYearlyPositiveAbsolute'}
        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={exporterYearlyNegativePercentageRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_14}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_14}
          title={t('mo_change_export_least_year')}
          type={TYPE.EXPORTER}
          isYearTable={true}
          data={marketOverviewData?.changes.exporter.yearly?.negative}
          timeTags={marketOverviewData?.changes.exporter.yearly?.timeTags}
          id={'exporterGraphYearlyNegativeAbsolute'}

        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={exporterMonthlyNegativePercentageRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_15}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_15}
          title={t('mo_change_export_most_month')}
          type={TYPE.EXPORTER}
          isYearTable={false}
          data={marketOverviewData?.changes.exporter.monthly?.positive}
          timeTags={marketOverviewData?.changes.exporter.monthly?.timeTags}
          id={'exporterGraphMonthlyPositiveAbsolute'}
        />
      </Col>
      <Col md="12">
        <ChangeCard
          ref={importerMonthlyNegativePercentageRef}
          code={Constants.BADGE_CODES.CHANGE_TABLE_16}
          graphicCode={Constants.BADGE_CODES.CHANGE_GRAPH_16}
          title={t('mo_change_export_least_month')}
          type={TYPE.EXPORTER}
          isYearTable={false}
          data={marketOverviewData?.changes.exporter.monthly?.negative}
          timeTags={marketOverviewData?.changes.exporter.monthly?.timeTags}
          id={'exporterGraphMonthlyNegativeAbsolute'}
        />
      </Col>
    </Row>
  </>)
})

export default ChangeSection
